import _ from 'lodash';

import { ILevelGeneralData, levelGeneralData } from 'src/app/infrastructure/models/level-general-data';
import { IAccountForm } from './account-form';
import { imageBoxDto } from 'src/assets/common/models/image-box-dto.g';
import { imageDto } from 'src/assets/common/models/image-dto.g';
import { IImageParentData, imageParentData } from 'src/app/features/image/models/image-parent-data';
import { IUserDto, userDto } from 'src/assets/common/models/user-dto.g';
import { IUserData } from 'src/app/features/user/models/user-data';

export type Role = 'user' | 'domainUser' | 'orderMember' | 'domainController' | 'orderController' | 'owner';

export const accountData = {
    ...levelGeneralData,
    ...imageParentData,
    
    guid: 'guid',
    applicationName: 'applicationName',
    firstName: 'firstName',
    lastName: 'lastName',
    correspondenceName: 'correspondenceName',
    email: 'email',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TAccountData = (typeof accountData)[keyof typeof accountData];

export interface IAccountData extends IUserData, ILevelGeneralData, IImageParentData {
    [accountData.guid]: string;
    [accountData.applicationName]: string | null;
    [accountData.firstName]: string | null;
    [accountData.lastName]: string | null;
    [accountData.correspondenceName]: string | null;
    [accountData.email]: string | null;
    [accountData.deleted]: boolean;
    [accountData.inactive]: boolean;

    [imageParentData.photoThumbGuid]: string | null;
    [imageParentData.photoVersion]: string | null;
    [imageParentData.photoOriginGuid]: string | null;
}

export class AccountData 
    implements IAccountData
{
    [accountData.guid]!: string;
    [accountData.applicationName]: string | null = null;
    [accountData.firstName]: string | null = null;
    [accountData.lastName]: string | null = null;
    [accountData.correspondenceName]: string | null = null;
    [accountData.email]: string | null = null;
    [accountData.deleted]!: boolean;
    [accountData.inactive]!: boolean;

    [imageParentData.photoThumbGuid]: string | null = null;
    [imageParentData.photoVersion]: string | null = null;
    [imageParentData.photoOriginGuid]: string | null = null;

    protected constructor(modelDto?: IUserDto | null);
    protected constructor(modelData: IAccountData, modelForm: IAccountForm);
    protected constructor(value?: IUserDto | IAccountData | null, modelForm?: IAccountForm) {
        if (!!modelForm) {
            const _modelData = value as IAccountData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IUserDto;
            this[accountData.guid] = _modelDto[userDto.guid]!;
            this[accountData.applicationName] = _modelDto[userDto.applicationName];
            this[accountData.firstName] = _modelDto[userDto.firstName];
            this[accountData.lastName] = _modelDto[userDto.lastName];
            this[accountData.correspondenceName] = _modelDto[userDto.correspondenceName];
            this[accountData.email] = _modelDto[userDto.email];
            this[accountData.deleted] = _modelDto[userDto.deleted]!;
            this[accountData.inactive] = _modelDto[userDto.inactive]!;

            this[accountData.photoThumbGuid] = _modelDto[userDto.photoBoxDto]?.[imageBoxDto.photoThumbDto]?.[imageDto.guid] ?? null;
            this[accountData.photoOriginGuid] = _modelDto[userDto.photoBoxDto]?.[imageBoxDto.photoDto]?.[imageDto.guid] ?? null;
            this[accountData.photoVersion] = _modelDto[userDto.photoBoxDto]?.[imageBoxDto.photoThumbDto]?.[imageDto.modifiedOn] ?? null;
        }
    }
        
    static create(modelDto?: IUserDto | null): IAccountData | null
    static create(modelData: IAccountData, modelForm: IAccountForm): IAccountData | null
    static create(value?: IUserDto | IAccountData | null, modelForm?: IAccountForm): IAccountData | null {

        if (!!modelForm) {
            const _modelData = value as IAccountData;
            return new AccountData(_modelData, modelForm);
        } else {
            const _modelDto = value as IUserDto;
            return _modelDto ? new AccountData(_modelDto) : null;
        }
    }
}
